import React, { useState, useContext, useEffect } from 'react';
import { useFetchSearch } from '../hooks/useFetchSearch';
import { useFetchGeom } from '../hooks/useFetchGeom';
import { AppContext } from '../components/AppContext';
import Loading from './Loading';

const SearchableSelect = () => {
  // { geoserverUrl, map, mapLayer, setGeom, load, m2load, onSelect }
  const { map, mapData, setGeom, config, setMapLegendData } = useContext(AppContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [option, setOption] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [geoserverUrl, setGeoserverUrl] = useState('');
  const [layer, setLayer] = useState('');
  const [variable, setVariable] = useState('');

  useEffect( () => {
    if (config) setGeoserverUrl(config.map.geoserverUrl)
  }, [config])

  useEffect( () => {
    if (mapData) setLayer(mapData.searchLayer)
  }, [mapData])

  useEffect( () => {
    if (mapData) setVariable(mapData.variable)
  }, [mapData])

  useEffect( () => {
    setSearchTerm('')
    setOption('')
    setGeom('')
    setMapLegendData('')
  }, [mapData])
  
  const mapLegendData = useFetchSearch(geoserverUrl, layer, variable);
  const geom = useFetchGeom(geoserverUrl, layer, variable, option );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleOptionClick = (option) => {
    // onSelect(option);
    setSearchTerm(option);
    setOption(option);
    setIsDropdownVisible(false);
    let bounds = mapLegendData.find(item => item.name === option).bbox
    map.fitBounds([ [bounds[1], bounds[0] ], [ [bounds[3], bounds[2] ] ] ])
  };

  useEffect( () => {
    // if(mapData.layerType === 'geometry') setGeom(geom)
    setGeom(geom)
}, [geom])
  // if (loadMapOption) return <Loading /> 
  if (mapLegendData !== '') {
    const mapVariableList = mapLegendData.map(item => item.name); 
    const filteredOptions = mapVariableList.filter(mapVariableList =>
    mapVariableList.toLowerCase().includes(searchTerm.toLowerCase())
    );
  return (
    <div className="searchable-select">
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        onFocus={() => setIsDropdownVisible(true)}
        onBlur={() => setTimeout(() => setIsDropdownVisible(false), 200)}
        placeholder="Seleccionar Ubicación"
        className="search-input"
      />
      {isDropdownVisible && filteredOptions.length > 0 && (
        <ul className="options-list">
          {filteredOptions.map((option, index) => (
            <li key={index} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
else return;
};


export default SearchableSelect;
